<template>
  <div class="content-wrapper">
    <div class="content-header row"></div>
    <div class="content-body">
      <section class="flexbox-container">
        <div class="col-md-4 offset-md-4 col-xs-10 offset-xs-1 box-shadow-2 p-0">
          <div class="card border-grey border-lighten-3 px-2 py-2 m-0">
            <div class="card-header no-border">
              <div class="card-title text-xs-center">
                <img src="/static/app-assets/images/logo/logo_tr.png" alt="CITY GAS SERVICE" />
              </div>
              <h6 class="card-subtitle line-on-side text-muted text-xs-center font-small-3 pt-2">
                <span>Создайте аккаунт. Только для физических лиц</span>
              </h6>
            </div>
            <div class="card-body collapse in">
              <p class="card-text text-xs-center">
                Регистрируясь в "личном кабинете" Вы соглашаетесь с
                <router-link to="offer">публичной офертой</router-link>.
              </p>
            </div>
            <div class="card-body collapse in">
              <div class="card-block">
                <form
                  v-if="!showMobileConfirmation"
                  class="form-horizontal form-simple"
                  @submit.prevent="register"
                >
                  <p v-if="showRegisterError" class="text-xs-center text-danger">{{registerError}}</p>
                  <fieldset class="form-group position-relative has-icon-left mb-1">
                    <input
                      type="text"
                      class="form-control form-control-lg input-lg"
                      id="name"
                      placeholder="Фамилия Имя"
                      v-model="name"
                      required
                    />
                    <div class="form-control-position">
                      <i class="icon-head"></i>
                    </div>
                  </fieldset>
                  <fieldset class="form-group position-relative has-icon-left mb-1">
                    <input
                      type="text"
                      class="form-control form-control-lg input-lg"
                      id="inn"
                      placeholder="ИНН"
                      v-model="inn"
                      required
                    />
                    <div class="form-control-position">
                      <i class="icon-head"></i>
                    </div>
                  </fieldset>
                  <fieldset class="form-group position-relative has-icon-left mb-1">
                    <select
                      class="form-control form-control-lg"
                      id="user-region"
                      required
                      v-model="region"
                    >
                      <option disabled selected value>Выберите регион</option>
                      <option v-for="r in getRegions" :key="r.id" :value="r.id">{{r.name}}</option>
                    </select>
                    <input type="hidden" class="form-control form-control-lg input-lg" />
                    <div class="form-control-position">
                      <i class="icon-earth"></i>
                    </div>
                  </fieldset>
                  <fieldset class="form-group position-relative has-icon-left mb-1">
                    <input
                      type="text"
                      class="form-control form-control-lg input-lg"
                      id="mobile"
                      placeholder="Сотовый номер"
                      v-model="mobile"
                      required
                      v-mask="'+7(799)999-99-99'"
                    />
                    <div class="form-control-position">
                      <i class="icon-phone"></i>
                    </div>
                  </fieldset>
                  <fieldset class="form-group position-relative has-icon-left mb-2">
                    <input
                      type="email"
                      class="form-control form-control-lg input-lg"
                      id="user-email"
                      placeholder="E-mail"
                      v-model="email"
                      aria-describedby="phoneHelp"
                    />
                    <div class="form-control-position">
                      <i class="icon-mail6"></i>
                    </div>
                    <small id="phoneHelp" class="form-text text-muted">Необязательное поле</small>
                  </fieldset>
                  <fieldset class="form-group position-relative has-icon-left mb-1">
                    <input
                      type="password"
                      class="form-control form-control-lg input-lg"
                      id="password"
                      placeholder="Пароль"
                      v-model="password"
                      required
                    />
                    <div class="form-control-position">
                      <i class="icon-key3"></i>
                    </div>
                  </fieldset>
                  <fieldset class="form-group position-relative has-icon-left">
                    <input
                      type="password"
                      class="form-control form-control-lg input-lg"
                      id="confirm_password"
                      placeholder="Потвердить пароль"
                      v-model="confirm_password"
                      required
                    />
                    <div class="form-control-position">
                      <i class="icon-key3"></i>
                    </div>
                  </fieldset>

                  <button type="submit" class="btn btn-primary btn-lg btn-block">
                    <i class="icon-unlock2"></i> Регистрация
                  </button>
                </form>
                <form v-else class="form-horizontal form-simple" @submit.prevent="confirm">
                  <p v-if="showConfirmError" class="text-xs-center text-danger">{{confirmError}}</p>
                  <fieldset class="form-group position-relative has-icon-left mb-1">
                    <input
                      disabled
                      type="text"
                      class="form-control form-control-lg input-lg"
                      id="mobile"
                      name="mobile"
                      placeholder="Сотовый номер"
                      v-model="mobile"
                      required
                    />
                    <div class="form-control-position">
                      <i class="icon-phone"></i>
                    </div>
                  </fieldset>
                  <fieldset class="form-group position-relative has-icon-left">
                    <input
                      type="password"
                      class="form-control form-control-lg input-lg"
                      id="confirm_code"
                      placeholder="Код из sms"
                      name="confirm_code"
                      v-model="confirm_code"
                      required
                    />
                    <div class="form-control-position">
                      <i class="icon-key3"></i>
                    </div>
                  </fieldset>
                  <template v-if="retryReady">
                    <button
                      type="button"
                      class="btn btn-link btn-block"
                      @click="register"
                    >Выслать код повторно</button>
                  </template>
                  <template v-else>
                    <p class="text-xs-center">
                      Повторный запрос sms через:
                      <span id="timeToRetry">{{timeToRetry}}</span>
                    </p>
                  </template>
                  <button type="submit" class="btn btn-primary btn-lg btn-block">
                    <i class="icon-unlock2"></i> Подтвердить
                  </button>
                </form>
              </div>
              <p class="text-xs-center">
                Уже зарегистрированны?
                <router-link to="/login" class="card-link">Вход в личный кабинет</router-link>
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import {
  REGISTER_REQUEST,
  REGISTER_CONFIRM_REQUEST,
} from "@/store/actions/auth";
import { REGIONS_REQUEST } from "@/store/actions/regions";
import { mapGetters } from "vuex";
export default {
  name: "Register",
  data() {
    return {
      name: null,
      inn: null,
      mobile: null,
      email: null,
      password: null,
      confirm_password: null,
      showRegisterError: false,
      registerError: null,
      showConfirmError: false,
      confirmError: null,
      showMobileConfirmation: false,
      timeToRetry: null,
      retryCounter: 0,
      retryReady: false,
      confirm_code: null,
      region: "",
    };
  },
  computed: {
    ...mapGetters(["getRegions"]),
  },
  methods: {
    register: function () {
      this.retryReady = false;
      this.showRegisterError = false;

      if (this.password !== this.confirm_password) {
        this.registerError = "Пароли не совпадают!";
        this.showRegisterError = true;
        return;
      }
      this.mobile = this.mobile.replace(/\D/g, "");
      const payload = {
        phone_number: this.mobile,
        body: JSON.stringify({
          name: this.name,
          inn: this.inn,
          email: this.email,
          password: this.password,
          region: this.region,
        }),
      };

      this.$store
        .dispatch(REGISTER_REQUEST, payload)
        .then(() => {
          this.showMobileConfirmation = true;
          const fiveMins = 5 * 60 * 1000;
          this.startRetryTimer(new Date(new Date().getTime() + fiveMins));
        })
        .catch((err) => {
          if (err.response.data.error === "you are very fast") {
            this.showMobileConfirmation = true;
            this.startRetryTimer(
              new Date(err.response.data.next_try + "+0000")
            );
          } else {
            switch (err.response.data.error) {
              case "already registered":
                this.registerError = "Данный мобильный номер уже занят!";
                break;
              default:
                this.registerError = err.response.data.errorж;
                break;
            }
            this.showRegisterError = true;
          }
        });
    },
    startRetryTimer(nextTryTime) {
      console.log("nextTryTime: " + nextTryTime);
      this.retryCounter = Math.ceil((nextTryTime - new Date()) / 1000);
      this.countDown();
    },
    countDown() {
      if (this.retryCounter) {
        return setTimeout(() => {
          let minutes = parseInt(this.retryCounter / 60, 10);
          let seconds = parseInt(this.retryCounter % 60, 10);

          minutes = minutes < 10 ? "0" + minutes : minutes;
          seconds = seconds < 10 ? "0" + seconds : seconds;

          this.timeToRetry = minutes + ":" + seconds;

          --this.retryCounter;
          this.countDown();
        }, 1000);
      }
      this.retryReady = true;
    },
    confirm() {
      this.showConfirmError = false;
      this.$store
        .dispatch(REGISTER_CONFIRM_REQUEST, {
          phone_number: this.mobile,
          confirm_code: this.confirm_code,
        })
        .then(() => {
          this.$router.push("/");
        })
        .catch((err) => {
          switch (err.response.data.error) {
            case "no registration data":
              this.confirmError = "Ошибка. Попробуйте обновить страницу";
              break;
            case "you are very tricky":
              this.confirmError =
                "Пользователь с вашим ИНН уже зарегистрирован. Если вы не регистрировались, обратитесь в офис";
              break;
            case "you are very dumb":
              this.confirmError = "Неверный код!";
              break;
            case "you are very slow":
              this.confirmError =
                "Время подтверждения истекло. Запросите новый код";
              break;
            default:
              this.confirmError = err.response.data.errorж;
              break;
          }
          this.showConfirmError = true;
        });
    },
  },
  created() {
    this.$store.dispatch(REGIONS_REQUEST);
  },
};
</script>